import Util from '@/lib/util'
export default [
   {
        title:Util.L('Name'),
        width:150,
        key:'productName'
    },{
        title:Util.L('Unit'),
        width:150,
        key:'unitName'
    },{
        title:Util.L('Category'),
        width:150,
        key:'categoryName'
    },{
        title:Util.L('BrandName'),
        width:150,
        key:'brandName'
    },{
        title:Util.L('ProductType'),
        width:150,
        key:'productTypeName'
    },{
        title:Util.L('AssetType'),
        width:150,
        key:'assetTypeName'
    },{
        title:Util.L('ConditionType'),
        width:100,
        key:'conditionTypeName'
    }]